import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import PageHeader from 'components/page-components/PageHeader';
import PageFooter from 'components/page-components/PageFooter';
import Homepage from 'pages/Homepage';
import MyHubRoute from './pages/MyHubRoute';
import Dashboard from 'pages/Dashboard';
import Dates from 'pages/Dates';
import Categories from 'pages/Categories';
import Identities from 'pages/Identities';
import Events from 'pages/Events';
import Triggers from 'pages/Triggers';
import Prizes from 'pages/Prizes';
import Predictions from 'pages/Predictions';
import CardPacks from 'pages/CardPacks';
import CardPacksOpen from 'pages/CardPacksOpen';
import MarketPlaceRoute from 'pages/MarketPlaceRoute';
import MarketPlaceCards from 'pages/MarketPlaceCards';
import MarketPlacePacks from 'pages/MarketPlacePacks';
import BuyPacks from 'pages/BuyPacks';
import CraftingRoute from 'pages/CraftingRoute';
import CraftIdentity from 'pages/CraftIdentity';
import CraftPrediction from 'pages/CraftPrediction';
import ProfileRoute from 'pages/ProfileRoute';
import Profile from 'pages/Profile';
import ProfilePredictionStatus from 'pages/ProfilePredictionStatus';
import ProfileTransactions from 'pages/ProfileTransactions';
import NotFound from 'components/NotFound';
import PagePopups from 'components/page-components/PagePopups';
import Privacy from 'pages/Privacy';
import Terms from 'pages/Terms';
import PageSound from 'components/page-components/PageSound';
import Rules from 'pages/Rules';
import { preloadSounds } from 'utils/soundsPreload';
import ProfileSettings from 'pages/ProfileSettings';
import PrivaciesRoute from 'pages/PrivaciesRoute';
import useProfile from 'hooks/useProfile';
import { useEffect } from 'react';
import LearnToPlay from 'pages/LearnToPlay';
import JotformAgent from 'components/JotformAgent';
import MastersEvent from 'pages/MastersEvent';
import PageRotatePhone from 'components/page-components/PageRotatePhone';
import PvpTournaments from 'pages/PvpTournaments';

function App() {
  const navigate = useNavigate();
  const {token} = useProfile();
  const { pathname } = useLocation();
  const soundMap = preloadSounds();

  useEffect(() => {
    if (token && pathname === '/') {
      navigate('/dashboard');
    }

    window.gtag('config', 'G-D5B5LE8PKJ', {
      page_path: pathname,
    });

  }, [pathname])


  return (
    <div className={`app ${pathname === '/' ? 'app--homepage' : ''}`}>

      <PageRotatePhone />
      <PageHeader />
      <Routes>
        <Route index element={<Homepage />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/inventory' element={<MyHubRoute />}>
          <Route path='dates' element={<Dates />} />
          <Route path='categories' element={<Categories />} />
          <Route path='identities' element={<Identities />} />
          <Route path='events' element={<Events />} />
          <Route path='triggers' element={<Triggers />} />
          <Route path='prizes' element={<Prizes />} />
          <Route path='predictions' element={<Predictions />} />
          <Route path='card-packs' element={<CardPacks />} />
          <Route path='card-pack-open/:id' element={<CardPacksOpen />} />
        </Route>
        <Route path='/crafting' element={<CraftingRoute />}>
          <Route path='identity' element={<CraftIdentity />} />
          <Route path='prediction' element={<CraftPrediction />} />
        </Route>
        <Route path='/marketplace' element={<MarketPlaceRoute />}>
          <Route path='cards' element={<MarketPlaceCards />} />
          <Route path='card-packs' element={<MarketPlacePacks />} />
        </Route>
        <Route path='/buypacks' element={<BuyPacks />} />
        <Route path='/mastersevent' element={<MastersEvent />} />
        <Route path='/pvp-tournaments' element={<PvpTournaments />} />
        <Route path='/profile' element={<ProfileRoute />}>
          <Route path='me' element={<Profile />} />
          <Route path='prediction-status' element={<ProfilePredictionStatus />} />
          <Route path='transactions' element={<ProfileTransactions />} />
          <Route path='settings' element={<ProfileSettings />} />
        </Route>
        <Route path='/privacies' element={<PrivaciesRoute />}>
          {/* <Route path='learn-to-play' element={<LearnToPlay />} /> */}
          <Route path='rules' element={<Rules />} />
          <Route path='privacy-policy' element={<Privacy />} />
          <Route path='terms-of-use' element={<Terms />} />
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      <PageFooter />
      <PagePopups />
      <PageSound soundMap={soundMap} />
      <JotformAgent />
    </div>
  );
}

export default App;
